import { render, staticRenderFns } from "./upload-task.vue?vue&type=template&id=066e3996&scoped=true&"
import script from "./upload-task.vue?vue&type=script&lang=js&"
export * from "./upload-task.vue?vue&type=script&lang=js&"
import style0 from "./upload-task.vue?vue&type=style&index=0&id=066e3996&prod&lang=css&"
import style1 from "./upload-task.vue?vue&type=style&index=1&id=066e3996&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066e3996",
  null
  
)

export default component.exports